import React from 'react';
import { Card, Button, Input, Space, Tag, Typography } from 'antd';
import { DeleteOutlined, PlusOutlined, ThunderboltOutlined } from '@ant-design/icons';

const { Text } = Typography;
const { TextArea } = Input;

export default function ParsedQaEditor({
  parsedPairs,
  onChange,
  analyzeDisabled,
  analyzing,
  onAnalyze,
}) {
  const updatePair = (id, patch) => {
    onChange(
      parsedPairs.map((pair) =>
        pair.id === id
          ? {
              ...pair,
              ...patch,
              editedByUser: true,
            }
          : pair,
      ),
    );
  };

  const addPair = () => {
    onChange([
      ...parsedPairs,
      {
        id: `parsed_manual_${Date.now()}`,
        questionRaw: '',
        answerRaw: '',
        parseConfidence: 1,
        parseWarnings: [],
        isRemoved: false,
        editedByUser: true,
      },
    ]);
  };

  const removePair = (id) => {
    onChange(parsedPairs.filter((pair) => pair.id !== id));
  };

  const activePairs = parsedPairs.filter((pair) => !pair.isRemoved);

  return (
    <Card bordered={false} style={{ borderRadius: '12px', boxShadow: '0 2px 12px rgba(0,0,0,0.03)' }}>
      <Space direction="vertical" size={16} style={{ width: '100%' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div style={{ fontSize: '15px', fontWeight: 700, color: '#1a1a1a', marginBottom: 6 }}>
              Preview parse thô
            </div>
            <Text type="secondary">
              Bạn có thể sửa, xoá hoặc thêm cặp Q/A trước khi bấm Phân tích bằng AI.
            </Text>
          </div>
          <Button icon={<PlusOutlined />} onClick={addPair}>
            Thêm cặp Q/A
          </Button>
        </div>

        <Space wrap>
          <Tag color="blue">Tổng parse: {parsedPairs.length}</Tag>
          <Tag color="green">Hợp lệ: {activePairs.filter((pair) => pair.questionRaw && pair.answerRaw).length}</Tag>
          <Tag color="orange">Có cảnh báo: {activePairs.filter((pair) => pair.parseWarnings?.length > 0).length}</Tag>
        </Space>

        <Space direction="vertical" size={12} style={{ width: '100%' }}>
          {parsedPairs.map((pair, index) => (
            <Card key={pair.id} size="small" style={{ borderRadius: '10px', borderColor: '#e5e7eb' }}>
              <Space direction="vertical" size={10} style={{ width: '100%' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Space>
                    <Text strong>Cặp #{index + 1}</Text>
                    <Tag color={pair.parseConfidence >= 0.8 ? 'green' : 'orange'}>
                      Confidence: {Math.round((pair.parseConfidence || 0) * 100)}%
                    </Tag>
                    {(pair.parseWarnings || []).map((warning) => (
                      <Tag key={warning} color="gold">
                        {warning}
                      </Tag>
                    ))}
                  </Space>
                  <Button danger type="text" icon={<DeleteOutlined />} onClick={() => removePair(pair.id)}>
                    Xoá
                  </Button>
                </div>

                <Input
                  value={pair.questionRaw}
                  onChange={(event) => updatePair(pair.id, { questionRaw: event.target.value })}
                  placeholder="Nhập câu hỏi"
                />
                <TextArea
                  rows={3}
                  value={pair.answerRaw}
                  onChange={(event) => updatePair(pair.id, { answerRaw: event.target.value })}
                  placeholder="Nhập câu trả lời"
                />
              </Space>
            </Card>
          ))}
        </Space>

        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            type="primary"
            icon={<ThunderboltOutlined />}
            disabled={analyzeDisabled}
            loading={analyzing}
            onClick={onAnalyze}
          >
            Phân tích bằng AI
          </Button>
        </div>
      </Space>
    </Card>
  );
}
